<template>
  <div v-if="comparison" class="comparison-container">
    <h3 class="mb-4">Comparativa con el Club</h3>

    <v-row>
      <!-- Tu Handicap -->
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card your-handicap">
          <v-card-text>
            <div class="stat-label">Tu Handicap</div>
            <div class="stat-value">{{ comparison.yourHandicap }}</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Promedio Club -->
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card">
          <v-card-text>
            <div class="stat-label">Promedio Club</div>
            <div class="stat-value">{{ comparison.clubAverage }}</div>
            <div :class="['stat-diff', getDiffClass(comparison.differenceVsAverage)]">
              {{ getComparisonLabel(comparison.differenceVsAverage) }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Posición en Ranking -->
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card ranking">
          <v-card-text>
            <div class="stat-label">Tu Posición</div>
            <div class="stat-value">{{ comparison.position }}</div>
            <div class="stat-meta">de {{ comparison.totalPlayers }}</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Percentil -->
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card percentile">
          <v-card-text>
            <div class="stat-label">Percentil</div>
            <div class="stat-value">{{ comparison.percentile }}%</div>
            <div class="stat-meta">mejor que el club</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Detalles -->
    <v-card class="mt-4">
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6">
            <div class="detail-row">
              <span class="detail-label">Mejor Jugador:</span>
              <span class="detail-value">{{ comparison.bestPlayerName }} ({{ comparison.bestPlayerHandicap }})</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Peor que mejor jugador:</span>
              <span class="detail-value error--text">
                +{{ (comparison.yourHandicap - comparison.bestPlayerHandicap).toFixed(1) }}
              </span>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="detail-row">
              <span class="detail-label">Jugadores mejor que tú:</span>
              <span class="detail-value">{{ comparison.betterThanYou }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Jugadores peor que tú:</span>
              <span class="detail-value">{{ comparison.worseThanYou }}</span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'HandicapComparison',
  props: {
    comparison: {
      type: Object,
      default: null
    }
  },
  methods: {
    getDiffClass (diff) {
      const diffValue = parseFloat(diff)
      if (diffValue < 0) return 'success--text' // Mejor que promedio
      if (diffValue > 0) return 'error--text' // Peor que promedio
      return 'grey--text' // Igual
    },
    getComparisonLabel (diff) {
      const diffValue = Math.abs(parseFloat(diff))
      if (diffValue < 0.1) return 'Igual al promedio'
      if (parseFloat(diff) < 0) return `↓ ${diffValue.toFixed(1)} mejor`
      return `↑ ${diffValue.toFixed(1)} peor`
    }
  }
}
</script>

<style scoped lang="scss">
.comparison-container {
  padding: 16px 0;
}

.stat-card {
  text-align: center;
  border: 1px solid #e0e0e0;

  &.your-handicap {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;

    .stat-label {
      opacity: 0.9;
    }

    .stat-value {
      color: white;
    }
  }

  &.ranking {
    background-color: #f5f5f5;
  }

  &.percentile {
    background-color: #e8f5e9;
  }
}

.stat-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #666;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 32px;
  font-weight: bold;
  color: #1976d2;
  margin-bottom: 4px;
}

.stat-meta {
  font-size: 11px;
  color: #999;
  font-weight: 500;
}

.stat-diff {
  font-size: 11px;
  font-weight: 600;
  margin-top: 4px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.detail-label {
  font-weight: 600;
  color: #666;
  font-size: 13px;
}

.detail-value {
  font-weight: 700;
  color: #1976d2;
  font-size: 13px;
}
</style>
